import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Block } from '@yooink/youi/dist/Layout/Block';
import { GeneralPage } from '../Analytics/general';
import '../../Styles/analytics.less';
import { MoySkladOrderErrors } from './MoySkladOrderErrors';
import Col from 'reactstrap/es/Col';
import Row from 'reactstrap/es/Row';
export function MainPage() {
    useEffect(() => {
        window.document.title = 'Главная';
    }, []);
    return (_jsx(_Fragment, { children: _jsxs(Row, { children: [_jsx(Col, Object.assign({ lg: 6 }, { children: _jsx(Block, { children: _jsx(GeneralPage, {}) }) })), _jsx(Col, Object.assign({ lg: 6 }, { children: _jsx(Block, { children: _jsx(MoySkladOrderErrors, {}) }) }))] }) }));
}
